import { render, staticRenderFns } from "./shanxiTrainingRecords.vue?vue&type=template&id=520b600e&scoped=true"
import script from "./shanxiTrainingRecords.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingRecords.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingRecords.vue?vue&type=style&index=0&id=520b600e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b600e",
  null
  
)

export default component.exports